import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { getDetailPagin } from 'src/common/helper';
import Pagin, { PaginationType } from 'src/components/common/Pagin';
import BtnGradient from 'src/components/common/button/BtnGradient';
import BtnOutlineGradient from 'src/components/common/button/BtnOutlineGradient';
import { useNotify } from 'src/context/ContextNotify';
import { deleteAPI, getAPI } from 'src/utils/api';
import DialogCreate from './dialog/create/DialogCreate';
import ConfirmDelete from 'src/components/common/modal/ConfirmDelete';
import DialogEdit from './dialog/edit/DialogEdit';
import { getToken } from 'src/utils/auth';

const QuestionList = () => {
  const notifyContext = useNotify();
  const [checkAPI, setCheckAPI] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [pagination, setPagination] = useState<PaginationType>();
  const [openConfirm, setOpenConfirm] = useState(false);
  const [deleteQuestionId, setDeleteQuestionId] = useState('0');
  const [openCreateQuestion, setOpenCreateQuestion] = useState(false);
  const [questionEdit, setQuestionEdit] = useState(null);
  const [openEditQuestion, setOpenEditQuestion] = useState(false);

  const getQuestionList = (page: number) => {
    setCheckAPI(false);
    const token = getToken();

    if (!token) {
      throw new Error('Failed to get access token');
    }
    getAPI(`/staff/questionnaires?page=${page}&pagesize=10&token=${token}`)
      .then((res) => {
        if (res.code === 200) {
          setQuestions(res.data.items);
          setPagination(res.data.pagination);
        }
      })
      .finally(() => {
        setCheckAPI(true);
      });
  };

  useEffect(() => {
    getQuestionList(1);
    // eslint-disable-next-line
  }, []);

  const handlePageChange = (eventL: any, value: number) => {
    getQuestionList(value);
  };

  const handleCloseConfirmDelete = () => {
    setOpenConfirm(false);
  };
  const handleDeleteClick = (form_id: string) => {
    setOpenConfirm(true);
    setDeleteQuestionId(form_id);
  };

  const handleDelete = () => {
    setOpenConfirm(false);
    try {
      const token = getToken();
  
      if (!token) {
        throw new Error('Failed to get access token');
      }
      deleteAPI(`/staff/questionnaires/${deleteQuestionId}?token=${token}`).then((res) => {
        if (res.code === 200) {
          notifyContext.setNotifyMessage({
            show: true,
            message: '削除しました。',
            type: 'success',
          });
          getQuestionList(1);
        }
        if (res.code === 500 || res.code === 501) {
          notifyContext.setNotifyMessage({
            show: true,
            message: res.msg,
            type: 'error',
          });
        }
      });
    } catch (error) {
      console.error('Failed to delete data:', error);
      return;
    }
  };
  const handleCreateNew = () => {
    setOpenCreateQuestion(true);
  };

  const handleSubmitCreateQuestion = () => {
    setOpenCreateQuestion(false);
    getQuestionList(1);
  };

  const handleCloseDialogCreateQuestion = () => {
    setOpenCreateQuestion(false);
  };

  const handleSubmitEditQuestion = () => {
    setOpenEditQuestion(false);
    getQuestionList(1);
  };

  const handleCloseDialogEditQuestion = () => {
    setOpenEditQuestion(false);
    setQuestionEdit(null)
  };

  const handleEditClick = (form_id: string) => {
    const token = getToken();

    if (!token) {
      throw new Error('Failed to get access token');
    }
    getAPI(`/staff/questionnaires/${form_id}?token=${token}`)
      .then((res) => {
        if (res.code === 200) {
          setQuestionEdit(res.data);
          setOpenEditQuestion(true)
        }
      })
      .finally(() => {});
  };
  return (
    <>
      <Stack width={'100%'}>
        <Stack
          direction={'row'}
          justifyContent={'space-between'}
          spacing={'8px'}
          mb={'30px'}
        >
          <BtnGradient
            text='新規作成'
            handleButtonClick={handleCreateNew}
            width='120px'
          />
        </Stack>
        <TableContainer
          component={Paper}
          sx={{
            boxShadow: 'none',
          }}
        >
          <Table
            sx={{
              minWidth: 650,
              '& .MuiTableCell-root.MuiTableCell-head': {
                borderBottom: '1px solid #F3F3F3',
                fontWeight: 700,
                p: '6px 16px',
                fontSize: '14px',
              },
              '& .MuiTableCell-root.MuiTableCell-body': {
                color: 'primary.dark',
                fontSize: '14px',
                py: '6px',
              },
            }}
            aria-label='simple table'
          >
            <TableHead>
              <TableRow>
                <TableCell>タイトル</TableCell>
                <TableCell>説明</TableCell>
                <TableCell>作成日</TableCell>
                <TableCell width={'100px'}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {checkAPI ? (
                <>
                  {questions.map((row: any, index) => (
                    <TableRow
                      hover
                      key={index}
                      sx={{
                        '&:last-child td, &:last-child th': { border: 0 },
                        '& .MuiTableCell-root.MuiTableCell-body': {
                          py: '4px',
                          borderBottom: '1px solid #F3F3F3',
                        },
                        cursor: 'pointer',
                      }}
                    >
                      <TableCell>{row.title}</TableCell>
                      <TableCell>{row.description}</TableCell>
                      <TableCell>
                        {dayjs(row.created_at).format('YYYY/MM/DD')}
                      </TableCell>
                      <TableCell>
                        <BtnOutlineGradient
                          text='変更'
                          handleButtonClick={() => handleEditClick(row.form_id)}
                        />
                      </TableCell>
                      <TableCell>
                        <BtnOutlineGradient
                          text='削除'
                          handleButtonClick={() =>
                            handleDeleteClick(row.form_id)
                          }
                          grandient='#DA4453'
                          color='#DA4453'
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                  {questions.length === 0 && (
                    <TableRow>
                      <TableCell
                        colSpan={11}
                        sx={{ textAlign: 'center', verticalAlign: 'center' }}
                      >
                        データがありません
                      </TableCell>
                    </TableRow>
                  )}
                </>
              ) : (
                <>
                  {Array.from(Array(10)).map((_, index) => {
                    return (
                      <TableRow key={index}>
                        {Array.from(Array(8)).map((_, index) => {
                          return (
                            <TableCell key={index}>
                              <Skeleton
                                variant='rounded'
                                width={'100%'}
                                height={30}
                              />
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                </>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {questions.length > 0 && pagination && (
          <Box display={'flex'} justifyContent={'right'} mt={'10px'}>
            <Typography
              component='label'
              sx={{
                color: '#AAB2BD',
                fontWeight: '400',
                fontSize: '10px',
                lineHeight: '12px',
              }}
            >
              {getDetailPagin(pagination)}
            </Typography>
          </Box>
        )}
        {questions.length > 0 && pagination && pagination.page && (
          <Pagin handlePageChange={handlePageChange} pagination={pagination} />
        )}
      </Stack>

      <ConfirmDelete
        openConfirm={openConfirm}
        handleCloseConfirmDelete={handleCloseConfirmDelete}
        handleDelete={handleDelete}
      />
      <DialogCreate
        open={openCreateQuestion}
        handleClose={handleCloseDialogCreateQuestion}
        handleConfirm={handleSubmitCreateQuestion}
      />
      <DialogEdit
        open={openEditQuestion}
        handleClose={handleCloseDialogEditQuestion}
        handleConfirm={handleSubmitEditQuestion}
        questionEdit={questionEdit}
      />
    </>
  );
};

export default QuestionList;
